import React from 'react';

export const RequiredTxt = () => {
  return <span style={{ color: 'red', position: 'relative', top: '3px' }}> *</span>;
};

export default RequiredTxt;
